import { Project } from './types';

export function tsUtility(): string {
  return 'ts-utility';
}

export function cloneMap<K, V>(map: Map<K, V>, valueCloner?: Project<V, V>): Map<K, V> {
  const clonedMap = new Map<K, V>();

  for (const [key, value] of map) {
    clonedMap.set(key, valueCloner?.(value) ?? value);
  }

  return clonedMap;
}

export function valuesOfMap<T, S>(map: Map<T, S> | ReadonlyMap<T, S>): S[] {
  const ret: S[] = [];

  for (const value of map.values()) {
    ret.push(value);
  }

  return ret;
}

export function throwError(message?: string): never {
  throw Error(message);
}

export function isTruthy<T>(value: T): boolean {
  return !!value;
}

export function isNotNullish<T extends null | undefined | any>(value: T): value is T {
  return value != null;
}

export function identity<T>(): Project<T, T> {
  return (self) => self;
}

export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export class Lazy<T> {
  private initialized = false;
  private _value!: T;

  constructor(private readonly factory: () => T) {}
  public get(): T {
    if (this.initialized) {
      return this._value;
    }

    this._value = this.factory();
    this.initialized = true;
    return this.get();
  }

  public reset() {
    this.initialized = false;
  }
}

export function keysOf<T extends object>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof T)[];
}

export function lazy<T>(factory: () => T): Lazy<T> {
  return new Lazy<T>(factory);
}

export interface LocalizedData<T> {
  en: T;
  ar: T;
}
